import React, {Component} from 'react';
import Table from '../../../components/common/Table';
import {Intent, PopoverInteractionKind, Position, Popover} from '@blueprintjs/core/lib/esm/index';
import InfoCircle from "../../common/InfoCircle";

class TeamTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            display: "none",
            opacity: '0',
            clicked_id: "",
            clicked_index: "",
            clicked_rmv_feed: ""
        };
    }

    toggleMemberData = (e) => {
        this.setState({
            clicked_id: e.target.id,
            clicked_index: e.target.name || e.target.title
        });
        if (this.state.display === "none") {
            this.setState({display: "block", opacity: '1'});

        } else {
            this.setState({display: "none"})
        }
    };

    handleFeedInTeam = (e) => {
        if (e.target.id === "remove_admin_from_feed" || this.state.clicked_rmv_feed) {
            this.setState({
                clicked_rmv_feed: ""
            });
        } else {
            this.setState({
                clicked_rmv_feed: e.target.title
            });
        }
    };

    toggleReassignPopUp = async () => {
        if (this.state.clicked_rmv_feed) {
            await this.setState({clicked_rmv_feed: ""})
            //console.log('Oplaio jeeee: ', this.state.clicked_rmv_feed)
        }
    }

    render() {
        const {feeds, onClick, onSort, sortColumn, team_id} = this.props;
        const {clicked_id, clicked_index, clicked_rmv_feed} = this.state;
        const columns = [
            {
                path: "name", label: "Workspace Name",
                content: item => <div>
                    {/*<img src={"http://emitto.producthive.tech/assets/media/feed-pictures/startit.png"}*/}
                    {/*alt="Feed IMG"/>*/}
                    {item.name}
                </div>
            },
            {
                path: "current_subscription", label: "Subscription",
                content: item => <div>
                    {!item || !item.current_subscription ? '' : !item.current_subscription.includes('martech') ?
                        item.current_subscription :
                        'Martech ' + item.current_subscription.slice(-1)
                    }
                </div>
            },
            {
                path: "admins", label: <React.Fragment><span>Workspace Admins</span>
                    <InfoCircle
                        icon='question'
                        infoCircleContent={<p className='info-circle-content'><strong>Workspace Admins</strong> <br/>
                            Can manage only workspaces they are assigned on.</p>}
                    /></React.Fragment>,
                content: item => <div className='flex-row'>

                    {item.admins && item.admins.map((admin, index) =>
                        <div className='table-admin'>
                            <Popover
                                interactionKind={PopoverInteractionKind.CLICK}

                                position={Position.LEFT_TOP}
                                style={{padding: 0}}
                                minimal={true}
                            >
                                <img id={admin.id} name={item.id} title={admin.first_name + " " + admin.last_name}
                                     src={admin.profile_photo || "/img/default-user.jpg"} alt="user"
                                     style={{marginRight: 0}}/>
                                <div className="team-user-panel padding-10" style={{display: 'block'}}>
                                    {/*<p className="close-panel">x</p>*/}
                                    <div className="display-flex" style={{display: 'flex', alignItems: 'center'}}>
                                        <div className="col-xs-3">
                                            <img style={{
                                                width: 50,
                                                height: 50,
                                                objectFit: 'cover',
                                                borderRadius: '100%'
                                            }}
                                                 src={admin.profile_photo || "/img/default-user.jpg"} alt="user"/>
                                        </div>
                                        <div className="col-xs-9">
                                            <div
                                                className="team-user-name">{admin.first_name + " " + admin.last_name}</div>
                                            <div className="team-user-email">{admin.email}</div>
                                        </div>
                                    </div>
                                    <a href="# " id="remove_admin_from_feed" title={item.id} name={admin.id}
                                       slot={admin.first_name + " " + admin.last_name}
                                       onClick={() => this.props.activateRemoveProjectAdminModal(item.id, item.name, admin, false)}>Remove
                                        from this
                                        workspace</a>
                                </div>
                            </Popover>
                        </div>
                    )}
                    {item.pending_admins && item.pending_admins.map((pending_admin, index) =>
                        <div className='table-admin' id={pending_admin.id} key={index} onClick={this.toggleMemberData}>
                            <Popover
                                interactionKind={PopoverInteractionKind.CLICK}

                                position={Position.LEFT_TOP}
                                style={{padding: 0}}
                                minimal={true}
                            >
                                <div className="pending-reg test-class"
                                     id={pending_admin.id}
                                     title={item.id}
                                     style={{
                                         cursor: "pointer",
                                         backgroundColor: "#F7F7F7",
                                         border: "1px solid #D6DBDF",
                                         color: "#344A5E",
                                         borderRadius: "100%",
                                         width: 31,
                                         height: 31,
                                         marginRight: 0
                                     }}>
                                </div>
                                <div className="team-user-panel padding-10" style={{display: 'block'}}>
                                    {/*<p className="close-panel">x</p>*/}
                                    <div className="display-flex">
                                        <div className="col-xs-3">
                                            <div className="pending-reg"
                                                 style={{

                                                     cursor: "auto",
                                                     backgroundColor: "#F7F7F7",
                                                     border: "1px solid #D6DBDF",
                                                     color: "#344A5E",
                                                     borderRadius: "100%",
                                                     height: 50,
                                                     width: 50,
                                                     fontSize: "37px",
                                                     textAlign: "center"
                                                 }}>
                                            </div>
                                        </div>
                                        <div className="col-xs-9">
                                            <div
                                                className="team-user-name">{pending_admin.name || "Registration pending"}</div>
                                            <div className="team-user-email">{pending_admin.email}</div>
                                        </div>
                                    </div>
                                    <a href="#" id="remove_pending_from_feed" title={item.id} name={pending_admin.id}
                                       slot={pending_admin.email}
                                       onClick={() => this.props.activateRemoveProjectAdminModal(item.id, item.name, pending_admin, true)}>Remove
                                        from this workspace</a>
                                </div>
                            </Popover>
                        </div>
                    )}
                    {
                        (this.props.user.user_type === 'reseller') &&
                        ((item.admins.length + item.pending_admins.length) > 0) ?
                            <Popover
                                interactionKind={PopoverInteractionKind.CLICK}

                                position={Position.CENTER}
                                minimal={true}
                            >
                                <p href="#"><span className="admin-icon fas fa-user-plus" id="add_admin_spec_feed"
                                                  title={item.name} slot={item.id}></span></p>
                                <p className='padding-10'>You reached maximum team members for current plan.</p>
                            </Popover>
                            :
                            (this.props.user.user_type === 'reseller') &&
                            ((item.admins.length + item.pending_admins.length) === 0) ?
                                <a href="# "><span className="admin-icon fas fa-user-plus" id="add_admin_spec_feed"
                                                   title={item.name}
                                                   slot={item.id} onClick={() => {
                                    // console.log('item mi daj: ', item)
                                    this.props.activateAddProjectAdminModal(item.id, item.name)
                                }}></span></a>
                                :
                                (item.team_members === '1') || (item.team_members === '5' && (item.admins.length + item.pending_admins.length) > 3) ?
                                    <Popover
                                        interactionKind={PopoverInteractionKind.CLICK}

                                        position={Position.CENTER}
                                        minimal={true}
                                    >
                                        <p><span className="admin-icon fas fa-user-plus"
                                                          id="add_admin_spec_feed"
                                                          title={item.name} slot={item.id}></span></p>
                                        <p className='padding-10'>You reached maximum team members for current plan.</p>
                                    </Popover>
                                    :
                                    <a href="# "><span className="admin-icon fas fa-user-plus" id="add_admin_spec_feed"
                                                       title={item.name}
                                                       slot={item.id} onClick={() => {
                                        // console.log('item mi daj: ', item)
                                        this.props.activateAddProjectAdminModal(item.id, item.name)
                                    }}></span></a>
                    }
                </div>
            },
            {
                path: "", label: "",
                content: item => <div>
                    <div className="feed-menu right d-inline-b">
                        <Popover
                            interactionKind={PopoverInteractionKind.CLICK}

                            position={Position.LEFT_TOP}
                            minimal={true}
                        >
                            <span id="feed-table-menu" title={item.id} className="fas fa-ellipsis-v"></span>
                            <div className="three-dots-popover padding-10">
                                <a href="# " id="reassign_feed" title={item.name} name={item.id} slot={team_id}
                                   onBlur={this.handleFeedInTeam}
                                   onClick={() => this.props.activateReassignProjectToTeamModal(item.id, item.name)}>Reassign</a>
                            </div>
                        </Popover>
                    </div>
                </div>
            }

        ];
        return (
            <div className="table-scroll m-lg-b">
                <Table
                    data={feeds}
                    columns={columns}
                    sortColumn={sortColumn}
                    onSort={onSort}
                    onClick={onClick}
                />
            </div>
        );
    }
}

export default TeamTable